import React, { Component } from 'react';
import Footer from '../../components/Footer';
import './index.less';
import anime from "animejs";
import history from '../../history';


export default class Nav extends Component{
    constructor(props){
        super(props);
        this.state={
            icon:'rect',
            points:'2 2, 18 2, 18 18, 2 18 2,2'
        }
    }
    //展开导航页面
    goNav = (e) => {
        const { icon } = this.state;
        let polyline =this.refs.polyline;
        let arg = icon||'rect';
        console.log(arg)
        let menu = document.getElementById("menu");
        let footer = document.getElementById("footer");
        if (arg === 'triggle') {
            console.log(menu.className)
            this.setState({
                icon:'rect',
                points:'2 2, 18 2, 18 18, 2 18 2,2'
            })
            polyline.style.animation='lineMove 4s linear 0s 1 alternate forwards';
            menu.className = 'close';
            anime.timeline({loop: 1})
                .add({
                    targets: '.title-name',
                    opacity:[1,0],
                    easing: "easeOutExpo",
                    duration: 300
                })
            setTimeout(function () {
                footer.style.display='none';
                menu.className = '';
                polyline.style.animation='';

            }, 1000)
        } else {
            console.log(menu.className)
            this.setState({
                icon:'triggle',
                points:'0 0, 15 11, 2 18 2,0'
            })
            polyline.style.animation='lineMove 4s linear 0s 1 alternate forwards';
            menu.className = 'show';

            setTimeout(function () {
                // menu.className = '';
                footer.style.display='block';
                polyline.style.animation='';
                anime.timeline({loop: 1})
                    .add({
                        targets: '.title-name',
                        opacity:[0,1],
                        easing: "easeInExpo",
                        duration: 300
                    })
            }, 1000)
        }

    };
    changeNav = (e) =>{
        const { icon } = this.state;
        let arg = icon||'rect';
        let menu = document.getElementById("menu");
        let footer = document.getElementById("footer");
        let change_icon = document.getElementById("change_icon");
        let _child1=change_icon.children[0];
        let _child2=change_icon.children[1];
        let _child3=change_icon.children[2];
        if (arg === 'triggle') {
            this.setState({
                icon:'rect'
            })
            // _child1.style='top: 11px; transform: matrix(0.7071, 0.7071, -0.7071, 0.7071, 0, 0)';
            _child1.style.top='4px';
            _child1.style.transform='matrix(1, 0, 0, 1, 0, 0)';
            _child2.style.top='11px';
            _child2.style.opacity=1;
            _child3.style.top='18px';
            _child3.style.transform='matrix(1, 0, 0, 1, 0, 0)';
            menu.className = 'close';
            anime.timeline({loop: 1})
                .add({
                    targets: '.title-name',
                    opacity:[1,0],
                    easing: "easeOutExpo",
                    duration: 300
                })
            setTimeout(function () {
                footer.style.display='none';
                menu.className = '';
            }, 1000)
        } else {
            console.log(menu.className)
            this.setState({
                icon:'triggle',
            })
            _child1.style.top='11px';
            _child1.style.transform='matrix(0.7071, 0.7071, -0.7071, 0.7071, 0, 0)';
            _child2.style.top='11px';
            _child2.style.opacity=0;
            _child3.style.top='11px';
            _child3.style.transform='matrix(-0.7071, 0.7071, -0.7071, -0.7071, 0, 0)';
            menu.className = 'show';
            setTimeout(function () {
                // menu.className = '';
                footer.style.display='block';
                anime.timeline({loop: 1})
                    .add({
                        targets: '.title-name',
                        opacity:[0,1],
                        easing: "easeInExpo",
                        duration: 300
                    })
            }, 1000)
        }
    }
    //跳转页面
    goPage = (name) => {
        let menu = document.getElementById("menu");
        // let polyline =this.refs.polyline;
        let change_icon = document.getElementById("change_icon");
        let _child1=change_icon.children[0];
        let _child2=change_icon.children[1];
        let _child3=change_icon.children[2];
        this.setState({
            icon:'rect',
        })
        // polyline.style.animation='lineMove 4s linear 0s 1 alternate forwards';
        _child1.style.top='11px';
        _child1.style.transform='matrix(0.7071, 0.7071, -0.7071, 0.7071, 0, 0)';
        _child2.style.top='11px';
        _child2.style.opacity=0;
        _child3.style.top='11px';
        _child3.style.transform='matrix(-0.7071, 0.7071, -0.7071, -0.7071, 0, 0)';
        setTimeout(function () {
            window.location.href = `/${name}`;
            // this.props.history.push(`/${name}`);
        },500)
    }
    handleMouse = (e) => {
        let target = e.target;
        let _val = e.target.innerText;
        document.onmousemove = () => {
            let changeVal='';
            // target.style.fontWeight = '400';
            switch (_val) {
                case 'HOME':
                    changeVal = '首页';
                    break;
                case 'CASES':
                    changeVal = '案例';
                    break;
                case 'PRODUCT':
                    changeVal = '产 品';
                    break;
                case 'NEWS':
                    changeVal = '新闻';
                    break;
                case 'ABOUT':
                    changeVal = '关于我们';
                    break;
                default:
                    changeVal = '联系方式';
                    break;
            }
            target.innerHTML = changeVal;
        };
        target.onmouseleave = () => {
            document.onmousemove = null;
            target.onmouseleave = null;
            // target.style.fontWeight = 'bold';
            let changeVal='';
            switch (_val) {
                case 'HOME':
                    changeVal = 'HOME';
                    break;
                case 'CASES':
                    changeVal = 'CASES';
                    break;
                case 'PRODUCT':
                    changeVal = 'PRODUCT';
                    break;
                case 'NEWS':
                    changeVal = 'NEWS';
                    break;
                case 'ABOUT':
                    changeVal = 'ABOUT';
                    break;
                default:
                    changeVal = 'CONTACT';
                    break;
            }
            target.innerHTML = changeVal;
        }
    }
    render() {
        return (
            <div >
                <div id="menu" className="">
                    <header className="nobackground">
                        <h1 className="white title-name"  style={{opacity:0}}><a href="/home">home</a></h1>
                    </header>
                    <div >
                        <nav>
                            <ul>
                                <li>
                                    <a id="home" className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('home',e)}>HOME</a>
                                </li>
                                <li>
                                    <a className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('case',e)}>CASES</a>
                                </li>
                                <li>
                                    <a className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('product',e)}>PRODUCT</a>
                                </li>
                                <li>
                                    <a className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('news',e)}>NEWS</a>
                                </li>
                                <li>
                                    <a className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('about',e)}>ABOUT</a>
                                </li>
                                <li>
                                    <a className="nav-underline" href="javascript:void(0)" onMouseOver={(e)=>this.handleMouse(e)} onClick={(e)=>this.goPage('contact',e)}>CONTACT</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    {/*<Footer/>*/}
                    <div className="footer-box1" id="footer" style={{display:'none'}}>
                        <a className="footer" href="http://www.jiangtour.com/">Site by:酱游科技  粤ICP备17047824号</a>
                    </div>
                </div>
                <div className="nav-icon">
                    {/*<svg version="1.1" onClick={(e) => this.goNav(e)} xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink"  className="circle-load-rect-svg" width="30" height="30" >
                        <polyline ref='polyline' points={this.state.points} fill="none" className="g-rect-fill"/>
                    </svg>*/}
                    <a href="javaScript:void(0);" className="menu-toggle show-menu" onClick={(e)=>this.changeNav(e)}>
                        <span className="icon rect-icon" id="change_icon">
                            <span className="l1" style={{top: '4px', transform: 'matrix(1, 0, 0, 1, 0, 0)'}}/>
                            <span className="l2" style={{top: '11px', opacity: 1}}/>
                            <span className="l3" style={{top: '18px', transform: 'matrix(1, 0, 0, 1, 0, 0)'}}/>
                        </span>
                       {/* <span className="icon triggle-icon" id="triggle_icon" style={{display:'none'}}>
                            <span className="l1" style={{top: '11px', transform: 'matrix(0.7071, 0.7071, -0.7071, 0.7071, 0, 0)'}}/>
                            <span className="l2" style={{top: '11px', opacity: 0}}/>
                            <span className="l3" style={{top: '11px', transform: 'matrix(-0.7071, 0.7071, -0.7071, -0.7071, 0, 0)'}}/>
                        </span>*/}
                    </a>
                </div>
            </div>
        )
    }
}
